// Event IDs that should display "Aikaero" instead of "Aika" for duration metric
const TIME_DIFFERENCE_EVENT_IDS_2022 = new Set([
  3566663, // Lumilautailu naiset, Parisuurpujottelun finaali
  3566631, // Lumilautailu miehet, Parisuurpujottelun finaali
  3566367, // Yhdistetty
  3566369, // Yhdistetty
  3566371, // Yhdistetty
]);

const TIME_DIFFERENCE_EVENT_IDS_2026 = new Set([
  4766721, // Lumilautailu, naiset, parisuurpujottelun finaali
  4766681, // Lumilautailu, miehet, parisuurpujottelun finaali
  4764650, // Yhdistetty
  4764652, // Yhdistetty
  4764654, // Yhdistetty
]);

/**
 * Get all event IDs that should display "Aikaero" instead of "Aika" for duration metric
 * Includes parisuurpujottelu and combined (yhdistetty) events
 *
 * @param year - The Olympic year (2022 or 2026)
 * @returns Set of event IDs that should use "Aikaero" label
 */
export function getTimeDifferenceEventIds(year: number): Set<number> {
  return year === 2022 ? TIME_DIFFERENCE_EVENT_IDS_2022 : TIME_DIFFERENCE_EVENT_IDS_2026;
}
